<template>
  <el-col style="text-align: center; overflow-y: scroll;padding-bottom: 100px;" class="content">
    <div style="width: 96%;margin-top: 2%; background-color: transparent;margin-left: 2%; font-family:'Microsoft YaHei';">
      <div style="
      font-weight: bold;
          text-align: left;
          font-size: 36px;
          color: #324157;
          letter-spacing: 0;
          line-height: 54px;">
        About the Global Change Risk Map Platform of <br/> Population and Economic Systems
      </div>

      <div style="font-size: 15px; margin-top: 20px;
            color: #8A8A8A;
            letter-spacing: 0;
            text-align: justify;
            line-height: 24px;">
        Global Change Risk Map Platform of Population and Economic Systems is a digital risk map platform that offers readers the systematic research results of the project <a href="http://gcr.bnu.edu.cn/?page_id=8]" target="_blank;" class="c_a">“Global Change Risk of Population and Economic Systems: Mechanisms and Assessments”</a> (Grant no. 2016YFA0602400).      </div>


      <div style="font-size: 26px;text-align: left;margin-top: 25px;
                  color: #324157;
                  letter-spacing: 0;">
        This digital risk map platform contains four themes:
      </div>

      <div style="font-size: 15px;text-align: left;margin-top: 20px;
            color: #324157;
            letter-spacing: 0;
            text-align: justify;
            line-height: 24px;">
        <span style="font-weight:bold;">Environment：</span><br/>
        covering world political maps, global satellite, global land cover, global soil, global climate zone, global river system, global land elevation, et al.
      </div>


      <div style="font-size: 15px;text-align: left;margin-top: 20px;
            color: #324157;
            letter-spacing: 0;
            text-align: justify;
            line-height: 24px;">
        <span style="font-weight:bold;">Climate system change：</span><br/>
        covering the mean, variability and extremes of temperature, precipitation, and wind speed.
      </div>

      <div style="font-size: 15px;text-align: left;margin-top: 20px;
            color: #324157;
            letter-spacing: 0;
            text-align: justify;
            line-height: 24px;">
        <span style="font-weight:bold;">Population and socioeconomic system changes：</span><br/>
        covering global population, gross domestic distribution, staple grain production, and their exposure to temperature and rainfall extremes.
      </div>

      <div style="font-size: 15px;text-align: left;margin-top: 20px;
            color: #324157;
            letter-spacing: 0;
            text-align: justify;
            line-height: 24px;">
        <span style="font-weight:bold;">Global change risks:</span><br/>
        co-driven by the two subsystems, covering population mortality risk due to heatwave and food, staple grain yield risk, and GDP loss risk to floods.
      </div>


      <img src="./img/introduction.jpg"  style="width: 100%;margin: 20px 0px;"/>


      <div style="font-size: 15px;text-align: left;margin-top: 0px;
            color: #324157;
            letter-spacing: 0;
            text-align: justify;
            line-height: 24px;">
        <span style="font-weight: bold;">T</span>he platform describes the changes by offering values of the baseline period (1986-2005), 2030s (2016-2035) and 2050s (2046-2064), and the absolute/relative changes of 2030s/2050s from the baseline.
        <br/><br/><span style="font-weight: bold;">I</span>t follows the CMIP5 scenarios by offering representative concentration pathways (RCPs) 2.6, 4.5 and 8.5, and in accordance with shared socioeconomic pathways (SSPs) 1, 2, and 3 whenever necessary, respectively.
        <br/><br/><span style="font-weight: bold;">I</span>t follows the rigorous multi-model ensemble approach by offering multi-model ensemble mean estimates (MME), and multi-model ensemble spread (MMS).
        <br/><br/><span style="font-weight: bold;">A</span>ll maps are digitally readable, and map data can be provided upon request. For each map group, meta data and contact information of map authors have been provided.
      </div>

    </div>
  </el-col>
</template>

<script>
export default {
  name: "Introduction"
}
</script>

<style scoped>

.c_a
{
  font-family: "Microsoft YaHei";
  font-size: 15px;
  color: deepskyblue;
  letter-spacing: 0;
  text-align: justify;
  line-height: 24px;
  font-weight: bold;
  font-style: italic;
}

.content{

}
.content::-webkit-scrollbar {
  display: none;/*隐藏滚动条*/
}

</style>



// WEBPACK FOOTER //
// src/view/BSD/About/Introduction.vue